import { render, staticRenderFns } from "./ContentCards.vue?vue&type=template&id=0c69810a&scoped=true&"
import script from "./ContentCards.vue?vue&type=script&lang=ts&"
export * from "./ContentCards.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCards.vue?vue&type=style&index=0&id=0c69810a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c69810a",
  null
  
)

export default component.exports